import { Grid } from '@mui/material'
import React from 'react'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import AppButton from '../../../commonComponents/AppButton'
import { useNavigate } from 'react-router-dom'

export default function ProfileCompletion ({ matches }) {
  const navigate = useNavigate()

  return (
    <Grid
      container
      spacing={2}
      style={{
        height: '70vh'
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Grid
          container
          spacing={2}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <CheckCircleOutlineRoundedIcon
              style={{ color: 'green', fontSize: '6rem' }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <TextBold style={{ fontSize: '25px' }}>Congratulations!</TextBold>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <TextRegular>
              You have successfully completed your profile. You're all set to
              start working on the job requisitions.
            </TextRegular>
          </Grid>
          <Grid
            item
            xs={matches ? 12 : 2}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <AppButton
              name={"Let's start recruiting"}
              onClick={() => navigate('/')}
              style={{ width: 'fit-content' }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
